import { IVehicle } from "interfaces/IVehicle"
import { useState } from "react"
import { RouteSelectContainer } from "./styles"
import { Input } from "components/Input"
import SearchIcon from 'assets/searchIcon.svg'
import CustomCheckBox from "components/checkbox"
import { toast } from "react-toastify"
import { driverVehicleService } from "services/driverVehicleService"

interface ISupportDriverFormProps {
  data: IVehicle[],
  setPopupVisible: (x: boolean) => void
  params: {
    search: string;
    notPaginated: boolean;
    deliveryDate: string;
    status: number;
  }
  fetchData: () => Promise<void>
}

export const SupportDriverForm = ({ data, setPopupVisible, params, fetchData }: ISupportDriverFormProps) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedVehicles, setSelectedVehicles] = useState<number[]>([])

  const handleCheckbox = async (element: number) => {
    if (selectedVehicles?.includes(element)) {
      setSelectedVehicles(state => ([...state?.filter((data: number) => data !== element)]));
    } else {
      setSelectedVehicles(state => ([...state, element]));
    }
  }

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setSearchTerm(value);
  };

  const handleSave = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (selectedVehicles.length === 0) {
      toast.warning("Selecione ao menos um veículo!")
      return
    }

    try {
      await driverVehicleService.postSupportDriver({
        vehiclesIds: selectedVehicles,
        deliveryDate: params.deliveryDate,
        status: params.status
      });
      toast.success("Motorista(s) adicionado(s) com sucesso!")
      fetchData()
    } catch (err: any) {
      if (err.message.includes("Driver Status already exists for vehicle")) {
        const vehicle = data.find(vehicle => vehicle.id === err.vehicle)
        return toast.warning(`Veículo ${vehicle?.name} - ${vehicle?.licensePlate} já está cadastrado como suporte ou indisponível!`);
      }
      if (err.message.includes("Vehicle not found")) {
        const vehicle = data.find(vehicle => vehicle.id === err.vehicle)
        return toast.warning(`Veículo ${vehicle?.name} - ${vehicle?.licensePlate} não foi encontrado`);
      }
      toast.error("Houve um erro ao adicionar os veículos como suporte: " + err.message)
    } finally {
      setPopupVisible(false)
    }
  }

  return (
    <form id="popupForm" autoComplete="false" onSubmit={handleSave}>
      <RouteSelectContainer>
        <div className="header">
          <div className="input">
            <img className="searchIcon" src={SearchIcon} alt="" />
            <Input
              className="inputBox"
              onChange={handleSearch}
              placeholder="Motorista ou Placa"
            />
          </div>
        </div>
        <div className="list">
          {data?.filter(item => 
            item?.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
            item?.licensePlate?.toLowerCase().includes(searchTerm.toLowerCase())
          )
            .sort((a, b) => a.name.localeCompare(b.name))
            .map(element => (
              <div className="entry" key={element.id} onClick={() => handleCheckbox(element.id)}>
                <button type="button" className="entryName" key={element.id}>
                  {`${element?.name} - ${element?.licensePlate}`}
                </button>
                <CustomCheckBox
                  checked={selectedVehicles?.includes(element.id)}
                  size="small"
                />
              </div>
            ))}
        </div>
      </RouteSelectContainer>
    </form>
  )
}
